import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../../common/GridLayout";
import CrateSubTabs from "./CrateSubTabs";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../../../../../gridLayoutCustomization/GridLayoutManager";
const CrateSearchFormResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const childRef = useRef();
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "ec96adca-c885-497d-81b8-06753eff86a7";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
        }
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="crateNumber" caption='Crate' dataType="string" ></Column>
                <Column dataField="description" caption='Description' dataType="string"></Column>
                <Column dataField="dimensions" caption='Dimensions' dataType="string"></Column>
                <Column dataField="height" caption='Height' dataType="number"></Column>
                <Column dataField="width" caption='Width' dataType="number"></Column>
                <Column dataField="depth" caption='Depth' dataType="number"></Column>
                <Column dataField="grossWeightQuantity" caption='Gross Weight Qty' dataType="number" ></Column>
                <Column dataField="netWeightQuantity" caption='Net Weight Qty' dataType="number"></Column>
                <Column dataField="receivedDate" dataType="date" caption='Received Date' ></Column>
                <Column dataField="shippedDate" dataType="date" caption='Shipped Date' ></Column>
                <Column dataField="location" caption='Location' dataType="string"></Column>
                <Column dataField="warehouse" caption='Warehouse' dataType="string"></Column>
                <Column dataField="recordNumber" caption="Record #" visible={false} dataType="string"></Column>
                <Column dataField="creationDateTime" caption="Creation Date Time" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="creationUserId" caption="Creation User ID" visible={false} dataType="string"></Column>
                <Column dataField="lastUpdateDateTime" caption="Last Update Date Time" visible={false} dataType="datetime" format="MM/dd/yyyy hh:mm:ss a"></Column>
                <Column dataField="lastUpdateUserId" caption="Last Update User ID" visible={false} dataType="string"></Column>
                <Column dataField="companyId" caption="Company" visible={false} dataType="string"></Column>
                <Column dataField="recordType" caption="Record Type" visible={false} dataType="string"></Column>
                <Column dataField="status" caption="Status" visible={false} dataType="string"></Column>
                <Column dataField="userdefinedCode1" caption="Code 1" visible={false} dataType="string"></Column>
                <Column dataField="userdefinedCode2" caption="Code 2" visible={false} dataType="string"></Column>
                <Column dataField="userdefinedCode3" caption="Code 3" visible={false} dataType="string"></Column>
                <Column dataField="userdefinedCode4" caption="Code 4" visible={false} dataType="string"></Column>
                <Column dataField="userdefinedCode5" caption="Code 5" visible={false} dataType="string"></Column>
                <Column dataField="userDefinedReference1" caption="Reference 1" visible={false} dataType="string"></Column>
                <Column dataField="userDefinedReference2" caption="Reference 2" visible={false} dataType="string"></Column>
                <Column dataField="userDefinedReference3" caption="Reference 3" visible={false} dataType="string"></Column>
                <Column dataField="userDefinedReference4" caption="Reference 4" visible={false} dataType="string"></Column>
                <Column dataField="userDefinedReference5" caption="Reference 5" visible={false} dataType="string"></Column>
                <Column dataField="locationDesc" caption="Location Description" visible={false} dataType="string"></Column>
                <Column dataField="warehouseName" caption="Warehouse Name" visible={false} dataType="string"></Column>

                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <CrateSubTabs ref={childRef} accessToken={accessToken} />
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CrateSearchFormResult);